import { RegistrationFormData, RegistrationStepProps } from "./StepModel";
import { Dispatch, useEffect, useState } from "react";
import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import {
  enableVerificationCodeResend,
  selectAllowResendVerificationCode,
  sendEmailVerificationCode,
  verifyEmail,
} from "../RegistrationPageSlice";
import OTPInput from "react-otp-input";
import { ErrorMessage } from "formik";
import { useThunkDispatch } from "setup/redux/thunkDispatch";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

export const EmailVerificationStep: React.FC<RegistrationStepProps> = ({
  currentStep,
  formikProps,
}: RegistrationStepProps) => {
  const [resendTimerSeconds, setResendTimerSeconds] = useState(30);
  const thunkDispatch = useThunkDispatch();
  const dispatch = useDispatch();
  const allowResendVerificationCode = useSelector(selectAllowResendVerificationCode);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (resendTimerSeconds > 1) {
        setResendTimerSeconds(resendTimerSeconds - 1);
      } else if (!allowResendVerificationCode) {
        dispatch(enableVerificationCodeResend());
      }
    }, 1000);

    return () => clearTimeout(timeout);
  }, [resendTimerSeconds, allowResendVerificationCode, dispatch]);

  return (
    <>
      {/* begin::Form group */}
      <div className="fv-row mb-3">
        <div className="verification-code-section">
          <div className="verification-code-label">Enter the verification code sent to your email: </div>
          <OTPInput
            inputStyle="inputStyle"
            value={formikProps.values.verificationCode}
            onChange={(otp: string) => {
              formikProps.setFieldValue("verificationCode", otp);
            }}
            numInputs={6}
            inputType="number"
            renderSeparator={(index) => (index === 2 ? <span>-</span> : "")}
            renderInput={(props, index) => <input {...props} data-test-id={`registration-form__code-input-${index}`} />}
          />

          <Link
            className="cpl-link cpl-text-primary fw-600 d-inline-block fs-7 mt-4"
            to=""
            data-test-id="registration-form__resend-code-button"
            onClick={() => {
              if (!allowResendVerificationCode) {
                return;
              }
              thunkDispatch(
                sendEmailVerificationCode({ emailAddress: formikProps.values.emailAddress, incrementStep: false })
              );
              setResendTimerSeconds(30);
            }}
          >
            {allowResendVerificationCode
              ? "Resend email verification code"
              : `Please wait ${resendTimerSeconds} seconds to resend verification code`}
          </Link>
        </div>
        <div className="fv-plugins-message-container">
          <div className="fv-help-block">
            <ErrorMessage name="verificationCode" key={currentStep.toString()} />
          </div>
        </div>
      </div>
      {/* end::Form group */}
    </>
  );
};

export const EmailVerificationSubmit = (
  values: RegistrationFormData,
  dispatch: Dispatch<AnyAction>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  thunkDispatch: ThunkDispatch<any, any, any>
) => {
  thunkDispatch(verifyEmail({ emailAddress: values.emailAddress, verificationCode: values.verificationCode }));
};
